import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash-es';
import theme from '../../../_shared/themes/tradeRev/theme';
import BaseModal from '../../../_shared/components/BaseModal';

import { ModalContainer, ModalHeader, ModalBody } from './Styles';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalBody: PropTypes.objectOf(PropTypes.any)
};

const defaultProps = {
  modalBody: undefined
};
const HelpModal = ({ isOpen, closeModal, modalBody }) => {
  const themeContext = useContext(ThemeContext);
  const isDesktop = useMediaQuery({
    query: `(min-width: ${themeContext.BP.TIAH_LARGE})`
  });

  const FeesTable = () => {
    return (
      <ModalBody.FeesContainer>
        <ModalBody.FeesTable>
          <ModalBody.TableHeaderRow>
            <ModalBody.TableHeaderCell>
              <FormattedMessage id="tiah.landing.FAQ.five.answer.auction.price" />
            </ModalBody.TableHeaderCell>
            <ModalBody.TableHeaderCell>
              <FormattedMessage id="tiah.landing.FAQ.five.answer.service.fee" />
            </ModalBody.TableHeaderCell>
          </ModalBody.TableHeaderRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>
              $2,500 <FormattedMessage id="tiah.landing.FAQ.five.answer.less" />
            </ModalBody.TableCell>
            <ModalBody.TableCell>$50</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>$2,501 – $5,000</ModalBody.TableCell>
            <ModalBody.TableCell>$150</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>$5,001 – $10,000</ModalBody.TableCell>
            <ModalBody.TableCell>$300</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>$10,001 – $20,000</ModalBody.TableCell>
            <ModalBody.TableCell>$500</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>$20,001 – $30,000</ModalBody.TableCell>
            <ModalBody.TableCell>$600</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>$30,001 – $50,000</ModalBody.TableCell>
            <ModalBody.TableCell>$750</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>$50,001 – $70,000</ModalBody.TableCell>
            <ModalBody.TableCell>$875</ModalBody.TableCell>
          </ModalBody.TableRow>
          <ModalBody.TableRow>
            <ModalBody.TableCell>
              $70,000{' '}
              <FormattedMessage id="tiah.landing.FAQ.five.answer.more" />
            </ModalBody.TableCell>
            <ModalBody.TableCell>$1000</ModalBody.TableCell>
          </ModalBody.TableRow>
        </ModalBody.FeesTable>
      </ModalBody.FeesContainer>
    );
  };

  return (
    <BaseModal
      isOpen={isOpen}
      width={375}
      padding="0"
      isClickEscClose
      isClickOverlayClose
      onRequestClose={closeModal}
      isFullScreen={!isDesktop}
      backgroundColor={theme.COLORS.NEUTRAL}
    >
      <ModalContainer>
        <ModalHeader>
          <ModalHeader.Button onClick={closeModal}>
            <ModalHeader.CloseIcon />
            <ModalHeader.Text>
              <FormattedMessage id="tiah.map.modal.close" />
            </ModalHeader.Text>
          </ModalHeader.Button>
        </ModalHeader>
        <ModalBody>
          {modalBody && !isEmpty(modalBody) ? (
            <>
              <ModalBody.Title>
                <FormattedMessage id={modalBody.question} />
              </ModalBody.Title>
              <ModalBody.FirstSection>
                <FormattedMessage
                  id={modalBody.answer}
                  values={{
                    breakingLine: <br />
                  }}
                />
                {modalBody.question === 'tiah.landing.FAQ.five.question' && (
                  <FeesTable />
                )}
              </ModalBody.FirstSection>
            </>
          ) : (
            <>
              <ModalBody.Title>
                <FormattedMessage id="tiah.map.modal.title" />
              </ModalBody.Title>
              <ModalBody.FirstSection>
                <FormattedMessage id="tiah.map.modal.firstsection" />
              </ModalBody.FirstSection>
              <ModalBody.ListHeader>
                <FormattedMessage id="tiah.map.modal.listheader" />
              </ModalBody.ListHeader>
              <ModalBody.List>
                <ModalBody.ListItem>
                  <FormattedMessage id="tiah.map.modal.listitem1" />
                </ModalBody.ListItem>
                <ModalBody.ListItem>
                  <FormattedMessage id="tiah.map.modal.listitem2" />
                </ModalBody.ListItem>
              </ModalBody.List>
              <ModalBody.LastSection>
                <FormattedMessage id="tiah.map.modal.lastsection" />
              </ModalBody.LastSection>
            </>
          )}
        </ModalBody>
      </ModalContainer>
    </BaseModal>
  );
};

HelpModal.propTypes = propTypes;
HelpModal.defaultProps = defaultProps;

export default HelpModal;
